/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ec33x5SEN4aEEFQbKCmZsX
// Component: lsUGdJlDUbSW
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/projectcss
import sty from "./PlasmicTopNavOld.module.css"; // plasmic-import: lsUGdJlDUbSW/css

createPlasmicElementProxy;

export const PlasmicTopNavOld__VariantProps = new Array("layoutType");

export const PlasmicTopNavOld__ArgProps = new Array(
  "pageButtons",
  "subdomainName"
);

const $$ = {};

function PlasmicTopNavOld__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          subdomainName: "subName"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "layoutType",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.layoutType
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"topnav"}
      data-plasmic-override={overrides.topnav}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.topnav,
        {
          [sty.topnavlayoutType_titleButtons]: hasVariant(
            $state,
            "layoutType",
            "titleButtons"
          )
        }
      )}
    >
      <div
        data-plasmic-name={"pageTitleSlot"}
        data-plasmic-override={overrides.pageTitleSlot}
        className={classNames(projectcss.all, sty.pageTitleSlot, {
          [sty.pageTitleSlotlayoutType_justTitle]: hasVariant(
            $state,
            "layoutType",
            "justTitle"
          ),
          [sty.pageTitleSlotlayoutType_titleButtons]: hasVariant(
            $state,
            "layoutType",
            "titleButtons"
          )
        })}
      >
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__eQGpA
          )}
        >
          {"o21p"}
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__qETU
          )}
        >
          {"|"}
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__u6Stj
          )}
        >
          <React.Fragment>
            {(() => {
              try {
                return $props.subdomainName;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "sub";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </div>
      </div>
      <div
        data-plasmic-name={"topnavButtonsSlot"}
        data-plasmic-override={overrides.topnavButtonsSlot}
        className={classNames(projectcss.all, sty.topnavButtonsSlot, {
          [sty.topnavButtonsSlotlayoutType_justTitle]: hasVariant(
            $state,
            "layoutType",
            "justTitle"
          ),
          [sty.topnavButtonsSlotlayoutType_titleButtons]: hasVariant(
            $state,
            "layoutType",
            "titleButtons"
          )
        })}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.pageButtons
        })}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  topnav: ["topnav", "pageTitleSlot", "topnavButtonsSlot"],
  pageTitleSlot: ["pageTitleSlot"],
  topnavButtonsSlot: ["topnavButtonsSlot"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTopNavOld__ArgProps,
          internalVariantPropNames: PlasmicTopNavOld__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTopNavOld__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "topnav") {
    func.displayName = "PlasmicTopNavOld";
  } else {
    func.displayName = `PlasmicTopNavOld.${nodeName}`;
  }
  return func;
}

export const PlasmicTopNavOld = Object.assign(
  // Top-level PlasmicTopNavOld renders the root element
  makeNodeComponent("topnav"),
  {
    // Helper components rendering sub-elements
    pageTitleSlot: makeNodeComponent("pageTitleSlot"),
    topnavButtonsSlot: makeNodeComponent("topnavButtonsSlot"),
    // Metadata about props expected for PlasmicTopNavOld
    internalVariantProps: PlasmicTopNavOld__VariantProps,
    internalArgProps: PlasmicTopNavOld__ArgProps
  }
);

export default PlasmicTopNavOld;
/* prettier-ignore-end */
